import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDeletePublicOfferApi } from '../api/delete-public-offer-api'
import { errorHandler } from '@/shared/lib/errorHandler'
import { notification } from '@/shared/helpers/notificationMessages'

export const useDeletePublicOffer = () => {
  const {
    mutateAsync,
    isPending: isLoadingDelete,
    isSuccess: isSuccessDelete,
  } = useDeletePublicOfferApi()
  const { t } = useTranslation(['common'])

  const handleOfferDelete = async (id: number, onClose: () => void) => {
    try {
      await mutateAsync(id)
    } catch (error) {
      errorHandler(error, t('common:notification_messages.delete_public_offer_error'))
    } finally {
      onClose()
    }
  }

  useEffect(() => {
    if (isSuccessDelete) {
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.delete_public_offer_success'),
      )
    }
  }, [isSuccessDelete])

  return {
    isLoadingDelete,
    handleOfferDelete,
  }
}
